import { GearCategory } from '@/modules/players/v3/types';

export const MY_GEAR_ALL_TAB_CATEGORY: GearCategory = {
  categoryId: -1,
  name: 'All',
  displayOrder: 0,
};

export const PROFILE_QUERY_KEY = 'player_gear_profile';

export const PLAYER_GEAR_QUERY_KEYS = [PROFILE_QUERY_KEY] as const;
